export default __webpack_public_path__ + "static/media/closePapyrus.f051f79c.svg";